import { __assign } from "tslib";
import { isPanelHeightSufficient } from '@cseo/coherence-utilities';
import { classNamesFunction, DefaultButton, getId, IconButton, Panel, PanelType, PrimaryButton } from '@fluentui/react';
import React from 'react';
var getClassNames = classNamesFunction();
var coherencePanelBase = function (props) {
    var styles = props.styles, titleText = props.titleText, onRenderFooter = props.onRenderFooter, theme = props.theme, hasCloseButton = props.hasCloseButton, panelSize = props.panelSize, isLightDismiss = props.isLightDismiss, backButton = props.backButton, children = props.children, panelBodyResponsiveMargin = props.panelBodyResponsiveMargin, onRenderHeader = props.onRenderHeader;
    var uniqueId = React.useState(getId('CoherPanel'))[0];
    React.useEffect(function () {
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var handleResize = function () {
        if (!isPanelHeightSufficient()) {
            setIsShort(true);
        }
        else if (isPanelHeightSufficient()) {
            setIsShort(false);
        }
    };
    var _a = React.useState(!isPanelHeightSufficient()), isShort = _a[0], setIsShort = _a[1];
    var classNames = getClassNames(styles, { theme: theme, isFooterInBody: (isShort), panelSize: panelSize, panelBodyResponsiveMargin: panelBodyResponsiveMargin });
    var _renderElement = function () {
        return (React.createElement(Panel, __assign({}, props, { id: uniqueId, headerText: titleText, hasCloseButton: _getCloseButton(), isLightDismiss: isLightDismiss !== undefined ? isLightDismiss : true, type: PanelType.custom, styles: classNames.subComponentStyles.panelStyles, isFooterAtBottom: true, onRenderHeader: _renderHeader, onRenderBody: _renderBody, onRenderFooter: _renderFooter, onRenderNavigationContent: _renderNavigation })));
    };
    var _renderNavigation = function (panelProps, defaultRender) {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classNames.backButtonContainer }, backButton && backButton.onClick && (React.createElement(IconButton, { iconProps: { iconName: 'Back' }, onClick: backButton.onClick, ariaLabel: backButton.ariaLabel ? backButton.ariaLabel : 'Back', className: classNames.backButton }))), (_a = props.onRenderAdditionalNavigationContent) === null || _a === void 0 ? void 0 :
            _a.call(props),
            defaultRender(panelProps)));
    };
    var _getCloseButton = function () {
        if (isShort) {
            return true;
        }
        else {
            return hasCloseButton !== undefined ? hasCloseButton : true;
        }
    };
    var _renderHeader = function (panelProps, defaultRender, headerId) {
        if (onRenderHeader) {
            return onRenderHeader(panelProps, _renderHeaderDefault, headerId);
        }
        return _renderHeaderDefault(panelProps, defaultRender, headerId);
    };
    var _renderHeaderDefault = function (_, __, headerId) {
        return (React.createElement("h1", { className: classNames.header, id: headerId }, titleText));
    };
    var _renderBody = function () {
        return (React.createElement("div", { className: classNames.body },
            children,
            _renderFooterContent(!isShort)));
    };
    var _renderFooter = function () {
        return _renderFooterContent(isShort);
    };
    var _renderFooterContent = function (_isShort) {
        if (!_isShort && onRenderFooter) {
            if (typeof onRenderFooter === 'function') {
                return (React.createElement("div", { className: classNames.footer }, onRenderFooter()));
            }
            else {
                return (React.createElement("div", { className: classNames.footer }, _renderButtons()));
            }
        }
        return null;
    };
    var _renderButtons = function () {
        var actionBar = onRenderFooter;
        return (React.createElement(React.Fragment, null,
            actionBar.primaryButton && actionBar.primaryButton.text && actionBar.primaryButton.onAction && (React.createElement(PrimaryButton, { disabled: !!actionBar.primaryButton.disabled, onClick: actionBar.primaryButton.onAction }, actionBar.primaryButton.text)),
            actionBar.secondaryButton && actionBar.secondaryButton.text && actionBar.secondaryButton.onAction && (React.createElement(DefaultButton, { disabled: !!actionBar.secondaryButton.disabled, onClick: actionBar.secondaryButton.onAction }, actionBar.secondaryButton.text))));
    };
    return _renderElement();
};
export { coherencePanelBase as CoherencePanelBase };
//# sourceMappingURL=CoherencePanel.base.js.map